import React, { useState } from "react";
import ButtonSaveForm from "../../components/forms/ButtonSaveForm";
import { Events } from "../../services/authService";

type Props = {
  onSubmit: (email: string, password: string, events?: Events) => Promise<any>;
  fetching: boolean;
};

const LoginForm: React.FC<Props> = ({ onSubmit, fetching }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);

  const callbackSave = async () => {
    try {
      const resp = await onSubmit(email, password, {
        onError: (r) => setError(r.message || "Error al iniciar sesión"),
      });
      return resp;
    } catch (err: any) {
      setError(err.message || "Error al iniciar sesión");
      throw err;
    }
  };

  const handleComplete = (ok: boolean, resp?: any) => {
    if (!ok) setError(resp?.message || "Error al iniciar sesión");
  };

  return (
    <div className="login-form">
      <input
        type="email"
        name="email"
        autoComplete="username"
        placeholder="Correo electrónico"
        aria-label="Correo electrónico"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onFocus={() => setError(null)}
        required
        autoFocus
      />

      <input
        type="password"
        name="password"
        autoComplete="current-password"
        placeholder="Contraseña"
        aria-label="Contraseña"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        onFocus={() => setError(null)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !fetching) callbackSave();
        }}
        required
      />

      <ButtonSaveForm
        callbackSave={callbackSave}
        locked={fetching}
        onComplete={handleComplete}
      >
        {fetching ? "Verificando..." : "Entrar"}
      </ButtonSaveForm>

      {error && (
        <p className="error-text" role="alert">
          {error}
        </p>
      )}
    </div>
  );
};

export default LoginForm;
